/**
 * @fileoverview Template: the mono-screen frame every page renders inside.
 * @module components/templates/PageTemplate
 */

import type { ReactNode } from "react"

import "./PageTemplate.css"

/** Props accepted by {@link PageTemplate}. */
export interface PageTemplateProps {
	/** Page heading, shown small in the top-right corner. */
	readonly title: string
	/** Page content. */
	readonly children: ReactNode
}

/**
 * Full-viewport page frame: a slim top-right heading over a content area
 * sized to fit without the page itself scrolling.
 *
 * @description
 * `.page__content` keeps a scroll fallback for the rare viewport too short
 * to fit everything (a large accessibility zoom, a tiny landscape phone) —
 * the target is scroll-free, not scroll-proof.
 *
 * @param props - Title and content.
 * @returns The rendered page shell.
 */
export function PageTemplate({ title, children }: PageTemplateProps) {
	return (
		<main className="page">
			<header className="page__header">
				<img
					className="page__logo"
					src="/favicon.svg"
					alt=""
					width={28}
					height={27}
				/>
				<h1 className="page__title">{title}</h1>
			</header>
			<div className="page__content">{children}</div>
		</main>
	)
}
